import { render, staticRenderFns } from "./GerenciaCadastroFuncionario.vue?vue&type=template&id=5384d433"
import script from "./GerenciaCadastroFuncionario.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroFuncionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports